export const SECTION_ANALYTICS_EVENTS = {
  jobPostCreated: "section job post created",
  changeRequestApproved: "section change request approved",
  changeRequestRejected: "section change request rejected",
  changeRequestUpdated: "section change request updated",
  changeRequestReassigned: "section change request reassigned",
  changeRequestSettingUpdated: "section change request setting updated",
  duesRatesUpdated: "section dues rates updated",
  duesRatesFinalized: "section dues rates finalized",
  catalogViewed: "section catalog viewed",
  catalogViewChanged: "section catalog view changed"
} as const;

export type SectionAnalyticsSource =
  | "section_jobs"
  | "section_change_requests"
  | "section_dues_rates"
  | "section_catalog";

export type SectionsCatalogViewModeAnalytics = "browse" | "list";

export type SectionAnalyticsData = {
  source: SectionAnalyticsSource;
  success: boolean;
  sectionId?: string;
  targetSectionId?: string;
  jobPostId?: string;
  changeRequestId?: string;
  settingId?: string;
  changeType?: string;
  action?: string;
  field?: string;
  approvalType?: string;
  previousApprovalType?: string;
  isDraft?: boolean;
  sentForReview?: boolean;
  stage?: string;
  hasMessage?: boolean;
  createsFollowUpTask?: boolean;
  rateCount?: number;
  membershipYear?: number;
  viewMode?: SectionsCatalogViewModeAnalytics;
  previousViewMode?: SectionsCatalogViewModeAnalytics;
};

export function getSectionAnalyticsData({
  source,
  success = true,
  ...rest
}: {
  source: SectionAnalyticsSource;
  success?: boolean;
} & Omit<SectionAnalyticsData, "source" | "success">): SectionAnalyticsData {
  return {
    source,
    success,
    ...Object.fromEntries(Object.entries(rest).filter(([, value]) => value !== undefined && value !== null))
  };
}
